import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import ViewDetailsButton from './ViewDetailsButton';
import ComingSoonTag from '../../../components/ComingSoonTag';

type SharedCardHeaderProps = {
  title: string;
  tooltipText?: string;
  disabled?: boolean;
  shouldShowViewButton?: boolean;
  onViewClick?: () => void;
  showComingSoon?: boolean;
};

export const SharedCardHeader = ({
  title,
  tooltipText,
  disabled = false,
  shouldShowViewButton = false,
  onViewClick = () => {},
  showComingSoon = disabled,
}: SharedCardHeaderProps) => {
  return (
    <div className="flex items-center justify-between h-[52px]">
      <div className="flex items-center">
        <span className="text-lg font-bold">{title}</span>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <InfoCircleFilled className={`ml-2 text-[#293241]`} />
          </Tooltip>
        )}
      </div>
      {Boolean(showComingSoon) && (
        <div style={{ marginRight: 0 }}>
          <ComingSoonTag />
        </div>
      )}
      {shouldShowViewButton && onViewClick && (
        <ViewDetailsButton onClick={onViewClick} />
      )}
    </div>
  );
};
